<div class="min-h-screen bg-gray-50 py-8 px-4" *ngIf="showFaq">
  <div class="max-w-4xl mx-auto">
    <div class="text-center mb-8">
      <h1 class="text-3xl font-bold text-gray-900 mb-4">¿Necesitas ayuda?</h1>
      <p class="text-lg text-gray-600">Accede a soporte rápido y efectivo según el tipo de consulta que tengas</p>
    </div>
    
    <div class="space-y-4">
      <!-- Sección 1: Dudas sobre seguro -->
      <div class="bg-white rounded-lg shadow-md overflow-hidden">
        <div class="p-6 cursor-pointer hover:bg-gray-50 transition-colors" (click)="toggleFaq(0)">
          <div class="flex justify-between items-center">
            <h3 class="text-lg font-semibold text-gray-900">Para dudas sobre tu seguro contratado con Banamex</h3>
            <svg class="w-5 h-5 text-gray-500 transform transition-transform" [class.rotate-180]="faqs[0].isOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </div>
        </div>
        <div class="px-6 pb-6" [class.hidden]="!faqs[0].isOpen">
          <div class="text-gray-700 leading-relaxed border-t pt-4">
            <p class="mb-2">Llama a los puntos de contacto:</p>
            <p class="mb-1"><strong>México: </strong><a href="tel:+525512268100" class="phone-link">55 1226 8100</a></p>
            <p class="mb-4"><strong>Extranjero: </strong><a href="tel:+18002262639" class="phone-link">1 800 226 2639</a></p>
            <p class="mb-1">Lunes a viernes de 08:00 a 20:00 hrs.</p>
            <p>Sábado de 08:00 a 16:00 hrs., horario de la Ciudad de México</p>
          </div>
        </div>
      </div>

      <!-- Sección 2: Soporte técnico -->
      <div class="bg-white rounded-lg shadow-md overflow-hidden">
        <div class="p-6 cursor-pointer hover:bg-gray-50 transition-colors" (click)="toggleFaq(1)">
          <div class="flex justify-between items-center">
            <h3 class="text-lg font-semibold text-gray-900">Soporte técnico o problemas con la aplicación</h3>
            <svg class="w-5 h-5 text-gray-500 transform transition-transform" [class.rotate-180]="faqs[1].isOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </div>
        </div>
        <div class="px-6 pb-6" [class.hidden]="!faqs[1].isOpen">
          <div class="text-gray-700 leading-relaxed border-t pt-4">
            <p class="mb-4"><strong>México y el extranjero: </strong><a href="tel:+525558094719" class="phone-link">55 5809 4719</a></p>
            <p>Lunes a domingo de 07:00 a 23:00 hrs.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>